<template>
        <li><a :href="'#' + item.id">{{item ? item['title_'+$i18n.locale.toUpperCase()]: ''}}</a>
        
          <ul >              
                <UserGuideTOC v-for="child in item.children" :key="'stoc_' + child.id" :item="child" :level="parseInt(level)+1"/>                            
          </ul>
        </li>
</template>



<script>
import { API_URL } from '@/.env'
// opts are optional
const opts = {
  xhtml: false,
  fqImages: { route: '/uploads', url: API_URL.url + '/doc/res' }, // use custom image endpoint url when link starts with route
  fqLinks: 'https://www.example.com',                                // generate fully qualified links if fqImages is not set
  relPath: true
}



export default {
  name: "UserGuideTOC",
  props: {
      item: { type: Object },
      lang: { type: String },
      jwt: { type: String },
      level: { type: Number}
  },
  data() {
          
  },

  components: {    
  },
  computed: {
    
  },
  watch: {
    
  },
  mounted() {

  },
  methods: {
   
  }
};
</script>

<style lang="scss" scoped>
.my-flex-card {
    height: calc(100% - 15px);
    margin-bottom: 15px;
}

.TreeNavigation {
    display: inline-block;
    padding: 0;
    margin: 0;
}


.NavigationToggle__icon {
    display: inline-block;
    padding: 3px;
    border: solid #000;
        border-top-width: medium;
        border-right-width: medium;
        border-bottom-width: medium;
        border-left-width: medium;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
}

.NavigationToggle {
    position: relative;
    top: -3px;
    padding: 5px 5px 5px 3px;
    cursor: pointer;
}

.guidecontent {
  font-size: x-large;
}

</style>